import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SxProps, Theme } from '@mui/system';
import { t } from 'i18next';

import { CompanyTypeahead } from '~hooks/useCompany/models';

import CustomAlert from './CustomAlert';

interface CompanyFoundCardProps {
  company: CompanyTypeahead;
  sx?: SxProps<Theme>;
  treadId: string;
}

export default function CompanyFoundCard({
  company,
  sx,
  treadId,
}: CompanyFoundCardProps) {
  return (
    <CustomAlert
      message={t('approvals.search_company_by_tread_id_success')}
      variant="success"
      sx={sx}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        <Typography sx={{ fontSize: '13px' }}>
          <b>{t('form_fields.company_name')}:</b> {company.legalName}
        </Typography>

        <Typography sx={{ fontSize: '13px' }}>
          <b>{t('form_fields.tread_id')}:</b> {treadId}
        </Typography>
      </Box>
    </CustomAlert>
  );
}
